import GlobalFields from 'defs/ga/fields/global';
import { CardActions, CardProps, PageView } from 'defs/ga/fields/product';

export const trackProductCardOpen = ({
	title,
	coachCardType,
	coachCardProdNm,
}: {
	coachCardProdNm: string;
	url: string;
	title: string;
	coachCardType: string;
}) => ({
	[GlobalFields.Event]: 'virtualPageview',
	[PageView.Title]: title,
	[CardProps.Type]: coachCardType,
	coachCardProdNm,
});

export const trackProductCardWidgetAction = ({
	coachCardProdId,
	coachCardProdNm,
	coachProgId,
	coachCardType,
}: {
	coachCardProdId: string | undefined;
	coachCardProdNm: string | undefined;
	coachCardType: string;
	coachProgId: string;
}) => ({
	[GlobalFields.Event]: 'buttonClick',
	[CardActions.ButtonText]: 'check',
	[CardActions.ProductName]: coachCardProdNm || '',
	[CardActions.ProductId]: coachCardProdId,
	[CardProps.Type]: coachCardType,
	coachProgId,
});
